import React from "react";
import { useTranslation } from "react-i18next";
import {
    DynamicTable,
    customColumnProps,
} from "@maherunlocker/custom-react-table";
import { useSnapshot } from "valtio";
import { StyledH2, StyledModal } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import classnames from "classnames";

import { store } from "@components/VerticalLayout/store";
import { setGlobalDataIsUpdated } from "./store";

import { BeforeModification } from "./BeforeModification";
import { AfterModification } from "./AfterModification";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { getArrayOfIds } from "./hooks";

import "@assets/swal.css";
import "@assets/theme.css";
import "react-toastify/dist/ReactToastify.css";
import "./index.css";
import { useAuthHeader } from "../../../api/headersKeycloak";

type DisplayNameType = {
    setTableState: Function;
    tableState: any;
    setModalState: Function;
    modalState: any;
    shops?: any;
};

export function History({
    modalState,
    setModalState,
    tableState,
    setTableState,
    shops,
}: DisplayNameType) {
    const { t } = useTranslation();
    const getAuthHeader = useAuthHeader();
    const i18nextLng = localStorage.getItem("i18nextLng") || "fr";
    const { userID, franchiseID } = useSnapshot(store);
    const [dataIsUpdated, setDataIsUpdated] = React.useState<boolean | number>(
        false
    );
    const [filterActive, setLocalFilterActive] = React.useState<boolean>(false);
    const [arrayIds, setArrayIds] = React.useState<any[]>([]);
    const url = `${
        process.env.REACT_APP_API_V2_URL
    }/settings/general/language/origin_history?userId=${userID}&franchiseId=${franchiseID}&languages=${arrayIds
        .map((el: any) => JSON.stringify(el))
        .join()}`;

    const ActionColumn = (e: any) => {
        return e.selectedRow.subRows === undefined ? <div></div> : null;
    };

    let arrayOfCustomColumns: customColumnProps[] = [
        {
            indexOFColumn: 2,
            columnName: t("Before modification"),
            customJsx: (e: any) => <BeforeModification e={e} />,
        },
        {
            indexOFColumn: 3,
            columnName: t("After modification"),
            customJsx: (e: any) => <AfterModification e={e} />,
        },
    ];

    React.useEffect(() => {
        getArrayOfIds(arrayIds, tableState, setArrayIds, t); // eslint-disable-next-line
    }, []);

    return (
        <StyledModal
            toggle={true}
            isOpen={modalState.isHistoryModalOpened!}
            centered
            className="modal-wrapper__clz"
            backdrop="static"
            fade={false}
            scrollable
        >
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setModalState({
                        ...modalState,
                        isHistoryModalOpened: !modalState.isHistoryModalOpened,
                    });
                    if (shops) setGlobalDataIsUpdated(false);
                    else
                        setTableState({
                            ...tableState,
                            dataIsUpdated: false,
                        });
                }}
            >
                <StyledH2 className="text-uppercase lan_txt_HStitleHistory">
                    {t("History")}
                </StyledH2>
            </ModalHeader>
            <ModalBody>
                <div
                    className={`${classnames("title__clz", {
                        "not-allowed-icon__clz":
                            tableState.selectedRows.length > 1,
                    })}`}
                >
                    {t("Language")}:{" "}
                    {tableState.selectedRows.length > 1
                        ? null
                        : tableState.rowData[t("Language")]}
                </div>
                <DynamicTable
                    requestHeader={{
                        "Accept-Language": i18nextLng,
                        ...getAuthHeader,
                    }}
                    url={url}
                    canResize
                    actionColumn={ActionColumn}
                    showGlobalFilter
                    showFilter
                    setLocalFilterActive={setLocalFilterActive}
                    filterActive={filterActive}
                    setDataIsUpdated={setDataIsUpdated}
                    dataIsUpdated={dataIsUpdated}
                    elevationTable={1}
                    minHeight="500px"
                    name="history"
                    arrayOfCustomColumns={arrayOfCustomColumns}
                />
            </ModalBody>
            <ModalFooter className="border-top-0">
                <CustomMainColorButton
                    variant="primary"
                    onClick={() => {
                        setModalState({
                            ...modalState,
                            isHistoryModalOpened: !modalState.isHistoryModalOpened,
                        });
                        if (shops) setGlobalDataIsUpdated(false);
                        else
                            setTableState({
                                ...tableState,
                                dataIsUpdated: false,
                            });
                    }}
                    rounded
                    className="lan_btn_HSclose"
                >
                    {t("Close")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
